var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 615.3 500",
    enableBackground: "new 0 0 615.3 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DC241F",
    d: "M469.4,250c0,89.1-72.3,161.3-161.3,161.3c-89.1,0-161.3-72.2-161.3-161.3c0-89.1,72.2-161.3,161.3-161.3 C397.2,88.7,469.4,160.9,469.4,250 M308.1,0C170,0,58.1,111.9,58.1,250c0,138.1,111.9,250,250,250c138.1,0,250-111.9,250-250 C558.1,111.9,446.2,0,308.1,0"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 199.5,
    fill: "#DC241F",
    width: 615.3,
    height: 101.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M217.4,276.1h-17.9V224h15.3c10.5,0,16.3,5.1,16.3,13c0,5-2.7,8.9-7.3,10.4c6.9,1.2,11.2,6.4,11.2,13.7 C235,268.2,229.9,276.1,217.4,276.1 M214.5,232.8h-4.9v11.5h4.6c4.2,0,6.8-2.2,6.8-5.7C221,235.1,218.6,232.8,214.5,232.8  M217.1,253.1h-7.6v14.1h6.8c5.2,0,8.4-2.4,8.4-6.8C224.7,255.2,221,253.1,217.1,253.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M285.7,268.6c-4.2,5.2-10.5,8.5-18.3,8.5c-7.8,0-14.1-3.2-18.4-8.6c-3.4-4.1-4.9-9-4.9-16V224h10.1v28.6 c0,8.9,5.2,14.8,13.1,14.8c8.2,0,13.2-5.9,13.2-14.8V224h10.1v28.2C290.7,259.4,289.4,264.1,285.7,268.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M315.6,277.1c-8.7,0-15.3-5.4-17.8-11l8.7-4.9c2.3,4.5,5.3,6.6,9.7,6.6c4.1,0,6.6-2.9,6.6-6.6 c0-3.4-2-5.5-7.4-8.3l-6.2-3.2c-5.9-3-8.7-7.8-8.7-13c0-8.1,6.8-13.6,15.4-13.6c7.3,0,12.5,3.4,14.8,9l-8.5,4.6 c-1.3-2.7-3.2-4.6-6.5-4.6c-3.3,0-5.4,1.8-5.4,4.4c0,2.9,2.3,4.2,6.9,6.4l5.8,2.8c6.6,3.2,9.8,8.4,9.8,15.3 C332.7,270.8,325.9,277.1,315.6,277.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "341.5,276.1 341.5,224 373.8,224 373.8,233.1 351.6,233.1 351.6,243.9 369.9,243.9 369.9,253.1  351.6,253.1 351.6,266.8 375.7,266.8 375.7,276.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M399.1,277.1c-8.7,0-15.3-5.4-17.8-11l8.7-4.9c2.3,4.5,5.3,6.6,9.7,6.6c4.1,0,6.6-2.9,6.6-6.6 c0-3.4-2-5.5-7.4-8.3l-6.2-3.2c-5.8-3-8.7-7.8-8.7-13c0-8.1,6.8-13.6,15.4-13.6c7.3,0,12.5,3.4,14.8,9l-8.5,4.6 c-1.3-2.7-3.2-4.6-6.5-4.6c-3.3,0-5.4,1.8-5.4,4.4c0,2.9,2.3,4.2,6.9,6.4l5.8,2.8c6.6,3.2,9.8,8.4,9.8,15.3 C416.2,270.8,409.4,277.1,399.1,277.1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.e0c72049f1f2a9f204c1be1384da1179.svg";
export { ForwardRef as ReactComponent };